import { render, staticRenderFns } from "./lawManager.vue?vue&type=template&id=5266d6fa"
import script from "./lawManager.vue?vue&type=script&lang=js"
export * from "./lawManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5266d6fa')) {
      api.createRecord('5266d6fa', component.options)
    } else {
      api.reload('5266d6fa', component.options)
    }
    module.hot.accept("./lawManager.vue?vue&type=template&id=5266d6fa", function () {
      api.rerender('5266d6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/law/lawManager.vue"
export default component.exports